const colors = {
  chartreuse: '#C8C04E',
  white: '#FFFFFF',
  greige: '#EBEBE5',
  lightGrey: '#d4dbdd',
  grey: '#808080',
  black: '#000000',
  red: '#B01818',
};

export default colors;
